//Third party libraries
import { Link, useLocation } from 'react-router';
//Services
import { useDashboardData } from '../../../hooks/ReactQueryHooks/useDashboardQuery';
//Assets and miscellaneous
import type { DashboardType } from '../../../types/Analytics';
import { getTdmCompleteOverCount } from '../../../utils/analytics';
//Custom components
import StatCard from '../../Sherpa/Projects/Project/StatCard/StatCard';
import { Widget } from '../constants';
import WidgetLayout from '../WidgetLayout';

export interface ProjectTypeProps {
  projectType: string;
  _count: number;
}

export default function TaskWidget({ dashboard }: { dashboard: DashboardType }) {
  const location = useLocation();
  const fetchTasksWidgetData = useDashboardData({
    dashboard,
    widget: Widget.TASKS_COUNT,
  });
  const tasksWidgetData = fetchTasksWidgetData?.data?.data;
  const tasksStat = getTdmCompleteOverCount(tasksWidgetData);

  return (
    <WidgetLayout dashboard={dashboard} widget={Widget.TASKS_COUNT}>
      <Link to={`${location.pathname}/tasks`}>
        <StatCard
          label='Tasks'
          stats={{
            completed: tasksStat.completeCount,
            total: tasksStat.totalCount,
          }}
        />
      </Link>
    </WidgetLayout>
  );
}
